import React,{Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import * as router from 'react-router-dom';
import {Container} from 'reactstrap';

import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_super_nav';
import visitor_super_navigation from '../../_visitor_tag_super_nav';
// routes config
import routes from '../../routes';
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";

import DefaultHeader from "./SuperHeader";
import DefaultFooter from "../DefaultLayout/DefaultFooter";
import $ from "jquery";
import Cookies from "js-cookie";
import JWT_Decode from "jwt-decode";
import {PropagateLoader} from "react-spinners";
import moment from "moment";

class SuperLayout extends Component {
  state = {
    loader:true
  };

  loading = () => <span/>;

  signOut(e) {
    e.preventDefault();
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    this.props.history.push('/login')
  }
  manageIframe = () => {
    this.setState({
      loader:false
    })
  };

  componentWillMount() {
    // console.log(moment(new Date()).add(6, 'hours').format('hh:mm A - DD MMM YYYY'));
    // for parktags -----------------------------------------------
    let token = Cookies.get("68a6102f6ed24899420170004a0273b8");
    let decode_token = JWT_Decode(token);

    decode_token.access_token = Cookies.get("68a6102f6ed24899420170004a0273b8");
    decode_token.refresh_token = Cookies.get("9b8558ba3f051677daf36ebfc67f29fa");

    decode_token.userId = decode_token.user.userId;
    decode_token.userRoles = decode_token.user.userRoles;
    decode_token.corporates = decode_token.user.corporates;

    sessionStorage.setItem("userData",JSON.stringify(decode_token));

    localStorage.setItem("userData",JSON.stringify(decode_token));
    localStorage.setItem("userId",decode_token.user.userId);
    localStorage.setItem("userRoles",decode_token.user.userRoles);
    // -----------------------------------------------------------
  }

  render() {
    let type = this.props.system_changer;
    if (type === 3)
      document.title = "Miracle Dome";
    if (type === 2)
      document.title = "Miracle Dome";
    if (type === 1)
      document.title = "Miracle Dome";

    return (
      <div className="app">
        <AppHeader fixed>
            <DefaultHeader history={this.props.history} onLogout={e => this.signOut(e)}/>
        </AppHeader>

        {
          this.props.system_changer === 1 ?
            <div className="app-body">
              <AppSidebar fixed display="lg">
                <AppSidebarHeader/>
                <AppSidebarForm/>

                  <AppSidebarNav navConfig={navigation} {...this.props} router={router}/>

                <AppSidebarFooter/>
                <AppSidebarMinimizer/>
              </AppSidebar>
              <main className="main">
                <AppBreadcrumb appRoutes={routes} router={router}/>
                <Container fluid>

                    <Switch>
                      {routes.map((route, idx) => {
                        return route.component ? (
                          <Route
                            key={idx}
                            path={route.path}
                            exact={route.exact}
                            name={route.name}
                            render={props => (
                              <route.component {...props} />
                            )}/>
                        ) : (null);
                      })}
                    </Switch>

                </Container>
              </main>

            </div>
            :
            this.props.system_changer === 2 ?
              <div className="app-body">
                <AppSidebar fixed display="lg">
                  <AppSidebarHeader/>
                  <AppSidebarForm/>

                    <AppSidebarNav navConfig={visitor_super_navigation} {...this.props} router={router}/>

                  <AppSidebarFooter/>
                  <AppSidebarMinimizer/>
                </AppSidebar>
                <main className="main">
                  <AppBreadcrumb appRoutes={routes} router={router}/>
                  <Container fluid>

                      <Switch>
                        {routes.map((route, idx) => {
                          return route.component ? (
                            <Route
                              key={idx}
                              path={route.path}
                              exact={route.exact}
                              name={route.name}
                              render={props => (
                                <route.component {...props} />
                              )}/>
                          ) : (null);
                        })}
                      </Switch>

                  </Container>
                </main>

              </div>
              :
              this.props.system_changer === 3 ?
                <div className="app-body">
                  {
                    this.state.loader ?
                      <div>
                        <div className="ant-modal-mask" style={{background: 'rgba(239, 239, 239, 0.4)'}}>
                        </div>

                        <div tabIndex="-1" style={{zIndex: '10000'}} className="ant-modal-wrap vertical-center-modal"
                             role="dialog">
                          <div className={"wrap-sweet-loading"}>
                            <div className='sweet-loading'>
                              <PropagateLoader
                                sizeUnit={"px"}
                                size={this.props.size ? this.props.size : 15}
                                color={this.props.color ? this.props.color : '#0085ca'}
                                loading={this.state.loading}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                      : null
                  }
                  <iframe src="/parktags/index.html" className={"iframe-tags parktags-iframe"} id={"iframe"}
                          onLoad={this.manageIframe}/>
                </div>
                :
                null
        }

        {
          this.props.system_changer !== 3 ?
            <AppFooter>
                <DefaultFooter/>
            </AppFooter>
            : null
        }

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SuperLayout);
